import React, { useContext } from 'react'
import CartCtx from '../CartCtx'
import { getFormatterCount } from './utils'

const ProductCountControl = (props) => {

    const { count_cart, removeProductCart, productState, isInputMode } = props
    const context = useContext(CartCtx)

    const step = productState?.step || 1

    const handleDown = () => {
        if (count_cart === 1) {
            removeProductCart(productState.id)
            return
        }
        context.setProductCount(productState.id, count_cart - 1)
    }
    const handleUp = () => {
        context.setProductCount(productState.id, count_cart + 1)
    }

    const handleChangeInput = (e) => {
        const rawValue = e.target.value

        if (rawValue === '') return

        const newValue = parseFloat(rawValue)
        if (isNaN(newValue)) return

        if (newValue) {
            context.setProductCount(productState.id, newValue)
        }
        else {
            context.setProductCount(productState.id, 1)
        }
    }

    return (
        <div className={`product-quantity`}>
            <div className='down' onClick={handleDown}>
                {
                    count_cart === 1 ?
                        <i className="i-remove" style={{ fontSize: 20 }} />
                        :
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                        </span>
                }
            </div>
            {
                isInputMode && step === 1 ?
                    <div className='count-input'>
                        <input
                            type='text'
                            value={getFormatterCount(count_cart, step)}
                            onChange={handleChangeInput}
                        />
                    </div>
                    :
                    <div className='count'>
                        {getFormatterCount(count_cart, step)}
                        <span>{productState?.unit && productState?.unit}</span>
                    </div>
            }
            <div className='up' onClick={handleUp}>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"  ><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </span>
            </div>
        </div>
    )
}

export default ProductCountControl